import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2E6100FD-8F6C-423C-BC18-372F8D57DC59
 * name blinds-horizontal
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blinds-horizontal.svg
 * tags
 * - Home Automation 
 */
export const BlindsHorizontalIcon = createSvgIcon(<><path d="M20 19V3H4V19H2V21H22V19H20M16 9H18V11H16V9M14 11H6V9H14V11M18 7H16V5H18V7M14 5V7H6V5H14M6 19V13H14V14.82C13.55 15.14 13.25 15.66 13.25 16.25C13.25 17.22 14.03 18 15 18S16.75 17.22 16.75 16.25C16.75 15.66 16.45 15.13 16 14.82V13H18V19H6Z" /></>, 'BlindsHorizontalIcon');
export default BlindsHorizontalIcon